import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { filter, firstValueFrom } from 'rxjs';
import { LayersService } from 'src/app/services/layers.service';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'app-homes-layer',
  imports: [],
  templateUrl: './homes-layer.component.html',
  styleUrl: './homes-layer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomesLayerComponent implements OnInit {
  constructor(
    private readonly modulesFacade: ModulesFacade,
    private readonly homesFacade: HomesFacade,
    private readonly userDataService: UserDataService,
    private readonly layersService: LayersService,
  ) {}

  async ngOnInit(): Promise<void> {
    await firstValueFrom(this.userDataService.loaded$.pipe(filter(loaded => !!loaded)));
    const homes = await firstValueFrom(this.homesFacade.homes$);

    const modules = await firstValueFrom(this.modulesFacade.modules$.pipe(filter(modules => modules.length > 0)));
    const homeStations = modules
      .filter(module => !module.mode && module.type === 'NAMain')
      .map(station => {
        const home = homes.find(home => home.id === station.homeId);
        return {
          ...station,
          coordinates: home.place.coordinates,
          city: station.name,
          altitude: home.place.altitude,
        };
      });

    this.layersService.setGeoJSONData('home-stations', homeStations, modules);
  }
}
